// 根据环境变量获取支持的语言切换
export const getSupportLanguages = () => {
  return import.meta.env.VITE_APP_LANGS.split(",");
};

export const DEFAULT_LANGUAGE = getSupportLanguages()[0];

const DEFAULT_LANGUAGE_MAP = {
  "zh-TW": {
    name: "繁體中文",
    urls: {
      facebook: "https://www.facebook.com/roo.gravity",
      youtube: "https://www.youtube.com/@Ragnarok_Origin",
      discord: "https://discord.com/invite/akcVsmUhBk",
    },
  },
  en: {
    name: "English",
    urls: {
      sea: {
        facebook: "https://www.facebook.com/rooglobal/",
        youtube: "https://www.youtube.com/@RagnarokOriginGlobal",
        discord: "https://discord.gg/rooglobal",
      },
      lna: {
        facebook: "https://www.facebook.com/OFFICIALRagnarokOriginROO",
        youtube: "https://www.youtube.com/@RagnarokOrigin_NA",
        discord: "https://discord.gg/roolna",
      },
    },
  },
  th: {
    name: "ไทย",
    urls: {
      facebook: "https://www.facebook.com/RagnarokOriginThailandOfficial/",
      youtube: "https://www.youtube.com/@RagnarokOriginTH",
      discord: "https://discord.gg/rooglobal",
    },
  }, // 泰语
  pt: {
    name: "Português",
    urls: {
      facebook: "https://www.facebook.com/RagnarokOriginROOPT",
      youtube: "https://www.youtube.com/@RagnarokOriginBR",
      discord: "https://discord.gg/roolna",
    },
  }, // 葡萄牙语
  hi: {
    name: "Bahasa Indonesia",
    urls: {
      facebook: "https://www.facebook.com/RagnarokOriginIndonesia",
      youtube: "https://www.youtube.com/@RagnarokOriginIndonesia",
      discord: "https://discord.gg/rooglobal",
    },
  }, // 印尼语
  es: {
    name: "Español",
    urls: {
      facebook: "https://www.facebook.com/RagnarokOriginROOSP",
      youtube: "https://www.youtube.com/@RagnarokOriginLATAM",
      discord: "https://discord.gg/roolna",
    },
  }, // 西语
} as const;

const langKeys = Object.keys(
  DEFAULT_LANGUAGE_MAP
) as (keyof typeof DEFAULT_LANGUAGE_MAP)[];

export const getSupportLanguagesMap = () => {
  return langKeys
    .map((lang) => ({
      name: DEFAULT_LANGUAGE_MAP[lang].name,
      value: lang,
      urls: DEFAULT_LANGUAGE_MAP[lang].urls,
    }))
    .filter((lang) => getSupportLanguages().includes(lang.value));
};

console.log(getSupportLanguagesMap());

export const communityType = {
  facebook: 1,
  youtube: 3,
  discord: 2,
};
